import React from 'react';
import AdminUsersContainer from '../components/adminUsers.container';

/** `/admin/users` — the user table. Filters and sort are held in the query string. */
const AdminUsersPage: React.FC = () => <AdminUsersContainer />;

export default AdminUsersPage;
